module.exports = __webpack_public_path__ + "static/media/214-Sturz-Milo_ID_5.8319f1fe.mp3";